import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
export function usePushModal(modalType) {
    const dispatch = useDispatch();
    return useCallback((params)=>{
        dispatch(pushModal(modalType, {
            wrapInModal: false,
            params
        }));
    }, [
        dispatch,
        modalType
    ]);
}
